import * as React from 'react';

const AlertIcon = ({
  height = '48px',
  width = '49px',
  ...props
}: React.SVGProps<SVGSVGElement> & { secondaryColor?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2922_24151)">
      <path
        d="M24.5001 33.75C23.2579 33.75 22.3345 34.7569 22.3345 36C22.3345 37.2422 23.3423 38.25 24.5001 38.25C25.7423 38.25 26.6657 37.2422 26.6657 36C26.7501 34.7531 25.747 33.75 24.5001 33.75ZM24.5001 30C25.3291 30 25.9157 29.3291 25.9157 28.5V15C25.9157 14.1709 25.245 13.5 24.5001 13.5C23.7553 13.5 23.0001 14.175 23.0001 15V28.5C23.0001 29.325 23.6751 30 24.5001 30ZM47.7782 37.2469L29.047 5.56687C28.1001 3.96281 26.3939 3.00281 24.5001 3C22.6064 3 20.9095 3.95813 19.9532 5.565L1.21261 37.2525C0.27042 38.8434 0.256357 40.7531 1.17306 42.3619C2.12104 44.0156 3.83292 45 5.75948 45H43.2501C45.1729 45 46.8829 44.0128 47.826 42.3591C48.7439 40.7531 48.7251 38.8406 47.7782 37.2469ZM45.1345 40.7906C44.8157 41.5781 44.0751 42 43.1657 42H5.75948C4.92454 42 4.18636 41.5796 3.78323 40.875C3.40092 40.2041 3.40683 39.4406 3.79788 38.7788L22.5407 7.09313C22.9439 6.40875 23.6751 6 24.5001 6C24.5001 6 24.4986 6 24.5001 6C25.3218 6.00146 26.0526 6.40866 26.4557 7.09125L45.1964 38.7788C45.5095 39.4406 45.6032 40.2 45.1345 40.7906Z"
        fill="#424242"
      />
    </g>
    <defs>
      <clipPath id="clip0_2922_24151">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default AlertIcon;
